import { ReactElement } from "react";
import { IContentAreaProps, IFilterData, ILadleStatus, IState } from "../../../types";
import { useSelector } from "react-redux";
import { Alert } from "@mui/material";
import LadleStatus from "./components/ladleStatus";
import { useFetch } from "../../../system/useFetch";
import SkeletonView from "../../../components/skeletonView";

const LadleStatusPage = ({ parentSize }: IContentAreaProps): ReactElement => {
  const filter = useSelector<IState, IFilterData>(state => state.filter);
  const { loading, error, data: ladleData } = useFetch<ILadleStatus[]>({ module: "meltShop", query: "getLadleStatus", payload: { ...filter.remote } });

  const style = {
    ...parentSize,
    overflow: "scroll"
  };

  const isMobile = parentSize.width < 400 || parentSize.height < 400;

  return(
    <div style={style} >
      {loading && <SkeletonView  parentSize={parentSize}/>}
      {error && <Alert severity="warning">{error.message}</Alert>}
      {!loading && !error && !ladleData && <Alert severity="warning">No Data to Display.</Alert>}

      {!loading && !error && ladleData &&
        <div className={`display-flex-row flex-wrap ${isMobile ? "justify-content-center" : ""}`} style={{ overflowY: "scroll" }}>
          { ladleData.map((item, index) => {
            return <LadleStatus key={`ladle-tracking-${index}`} ladleData={item} />;
          })
          }
        </div>
      }
    </div>
  );
};

export default LadleStatusPage;
